import { forwardRef } from 'react';

export function fixedForwardRef<T, P = {}>(
  render: (props: P, ref: React.Ref<T>) => JSX.Element,
): (props: P & React.RefAttributes<T>) => JSX.Element {
  return forwardRef(render) as any;
}
